import React from 'react';
import { motion } from 'framer-motion';
import { LogoMark } from '../components/LogoMark';
const POINTS = [{
  label: 'Field-built, not theory',
  text: 'Drawn from the real work of mine geology — mapping, grade control, reconciliation and the calls made under pressure.'
}, {
  label: 'One clear framework',
  text: 'Inputs → Interpretation → Decisions → Feedback → Improvements, held together by people, processes and standards.'
}, {
  label: 'Free and useful first',
  text: 'Genuinely useful guides and tools. No hard sell, no fake proof — take what helps and stay if it earns it.'
}];
export function CredibilityStrip() {
  return <section className="w-full border-b border-charcoal/10 bg-cream py-14 lg:py-16" data-id="element-447">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-448">
        <div className="grid items-center gap-10 lg:grid-cols-12" data-id="element-449">
          <div className="lg:col-span-5" data-id="element-450">
            <div className="flex items-start gap-4" data-id="element-451">
              <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl border border-charcoal/10 bg-sand" aria-hidden data-id="element-452">
                <LogoMark className="h-7 w-7" data-id="element-453" />
              </div>
              <div data-id="element-454">
                <p className="text-xs font-bold uppercase tracking-widest text-warmgray" data-id="element-455">
                  Behind Mine Geology Systems
                </p>
                <h2 className="mt-1 text-xl font-black leading-tight text-charcoal" data-id="element-456">
                  Built by a working mine geologist, for mine geologists.
                </h2>
                <p className="mt-2 text-sm leading-relaxed text-warmgray" data-id="element-457">
                  Jordan Biglin is building MGS from the inside of the
                  discipline — as a working mine geologist, not an outside
                  consultant selling a process.
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7" data-id="element-458">
            <div className="grid items-stretch gap-4 sm:grid-cols-3" data-id="element-459">
              {POINTS.map((p, i) => <motion.div key={p.label} initial={{
              opacity: 0,
              y: 12
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-40px'
            }} transition={{
              duration: 0.35,
              delay: i * 0.06
            }} className="flex h-full flex-col rounded-xl border border-charcoal/10 bg-sand p-4" data-id="element-460">
                  <p className="flex items-center gap-2 text-sm font-bold text-charcoal" data-id="element-461">
                    <span className="h-2 w-2 rounded-sm bg-yellow" data-id="element-462" />
                    {p.label}
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-warmgray" data-id="element-463">
                    {p.text}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}